import Seo from "@/components/Seo";

export default function InformativaCandidati() {
  return (
    <>
      <Seo
        title="Informativa privacy per candidati | Lovac"
        description="Informativa sul trattamento dei dati personali per i candidati Lovac ai sensi del GDPR (Reg. UE 2016/679)."
        path="/informativa-candidati"
      />
      <section className="bg-lovac-dark text-on-dark grain relative overflow-hidden">
        <div className="container-lovac px-6 pt-24 pb-16 relative z-10">
          <span className="badge-on-dark">Informativa candidati</span>
          <h1 className="font-display text-4xl sm:text-5xl mt-6 text-on-dark">
            Informativa privacy per candidati
          </h1>
          <p className="text-on-dark-muted text-base mt-4 max-w-2xl">
            Ai sensi del Regolamento UE 2016/679 (GDPR) e del D. Lgs. 196/2003.
          </p>
        </div>
      </section>

      <section className="section bg-lovac">
        <div className="container-narrow prose-lovac space-y-8">
          <Block title="1. Titolare del trattamento">
            Venditore a Distanza Srl, Via Zoe Fontana 220, 00131 Roma (RM). P.IVA 15627561002.
            Contatto: <a href="mailto:privacy@lovac.it" className="link-underline">privacy@lovac.it</a>.
          </Block>

          <Block title="2. Finalità del trattamento">
            I dati personali raccolti vengono trattati per le seguenti finalità:
            <ul className="list-disc pl-6 mt-3 space-y-1.5">
              <li>valutazione del profilo professionale in relazione a opportunità di lavoro;</li>
              <li>inserimento del candidato nel nostro database;</li>
              <li>contatto per finalità di selezione, anche per posizioni future compatibili;</li>
              <li>adempimenti contrattuali, legali e fiscali.</li>
            </ul>
          </Block>

          <Block title="3. Base giuridica">
            Il trattamento si fonda sul consenso libero, specifico, informato e inequivocabile del candidato (art. 6, par. 1, lett. a, GDPR) e su obblighi di legge connessi all'attività di intermediazione del lavoro.
          </Block>

          <Block title="4. Categorie di dati trattati">
            Dati anagrafici, di contatto, curriculum vitae, informazioni sulla carriera, foto del CV, eventuali dati relativi a categorie protette (ai sensi della L. 68/99) se forniti volontariamente.
          </Block>

          <Block title="5. Modalità del trattamento">
            <p>
              I dati sono trattati con strumenti informatici e cartacei, con misure idonee a garantire sicurezza e riservatezza. Possono essere consultati esclusivamente dal personale autorizzato di Lovac e, solo previa anonimizzazione o autorizzazione del candidato, condivisi con le aziende clienti.
            </p>
            <p className="mt-4">
              Ai fini della selezione, il curriculum del candidato viene inoltre elaborato tramite strumenti di intelligenza artificiale (le API di Anthropic Claude e/o OpenAI GPT), al fine di generarne una sintesi e di estrarre automaticamente le informazioni rilevanti per la compilazione dei relativi campi all'interno del software gestionale proprietario utilizzato da Lovac per il processo di selezione. Anthropic e OpenAI operano in tale contesto in qualità di responsabili del trattamento, nominati ai sensi dell'art. 28 GDPR.
            </p>
          </Block>

          <Block title="5-bis. Trasferimento dei dati verso paesi extra-UE">
            <p>
              L'elaborazione del CV tramite i suddetti strumenti di intelligenza artificiale può comportare un trasferimento di dati personali verso gli Stati Uniti. Tale trasferimento avviene sulla base delle Clausole Contrattuali Standard approvate dalla Commissione Europea e/o di altre garanzie adeguate previste dai fornitori, come indicato nella documentazione di data processing resa disponibile da Anthropic e da OpenAI.
            </p>
            <p className="mt-4">
              Il trattamento tramite intelligenza artificiale non comporta una decisione automatizzata che produce effetti giuridici sul candidato ai sensi dell'art. 22 GDPR: l'esito del processo di selezione è sempre determinato da valutazione umana del personale Lovac.
            </p>
          </Block>

          <Block title="6. Conservazione">
            I dati sono conservati per il tempo necessario alle finalità della selezione, e comunque per un massimo di 24 mesi dall'ultimo contatto utile, salvo richiesta di cancellazione anticipata.
          </Block>

          <Block title="7. Diritti dell'interessato">
            Il candidato può in qualsiasi momento esercitare i diritti di cui agli artt. 15–22 GDPR (accesso, rettifica, cancellazione, limitazione, portabilità, opposizione) scrivendo a <a className="link-underline" href="mailto:privacy@lovac.it">privacy@lovac.it</a>.
          </Block>

          <Block title="8. Accreditamento">
            Lovac opera tramite Venditore a Distanza Srl, accreditata ai Servizi per il Lavoro presso la Regione Lazio con Determinazione n. G04261 del 09 aprile 2026.
          </Block>

          <Block title="9. Siti a cui si applica la presente informativa">
            La presente informativa si applica alla raccolta dei dati dei candidati effettuata tramite i seguenti siti web, gestiti dal medesimo Titolare del trattamento sopra indicato: <a href="https://lovac.it" className="link-underline">lovac.it</a> e <a href="https://saleshunter.it" className="link-underline">saleshunter.it</a>.
          </Block>
        </div>
      </section>
    </>
  );
}

const Block = ({ title, children }) => (
  <div>
    <h2 className="font-display text-2xl text-lovac-dark">{title}</h2>
    <div className="text-base text-lovac-dark mt-3 leading-relaxed">{children}</div>
  </div>
);
